<div class="mt-2">
  @if (loading()) {
    <div class="flex flex-col gap-3">
      @for (i of [0, 1, 2]; track i) {
        <soft-ds-card density="compact" accent="primary">
          <div class="flex flex-col gap-2">
            <soft-ds-loading-skeleton width="35%" height="12px" radius="4px" />
            <soft-ds-loading-skeleton width="50%" height="18px" radius="4px" />
            <soft-ds-loading-skeleton width="20%" height="12px" radius="4px" />
          </div>
        </soft-ds-card>
      }
    </div>
  } @else if ((all() ?? []).length === 0) {
    <div class="flex min-h-[45dvh] grow items-center justify-center">
      <soft-ds-empty-state
        title="Keine Arbeitsberichte"
        description="Für diesen Tag wurden keine Arbeitsberichte gefunden."
      />
    </div>
  } @else {
    <div class="flex flex-col gap-3">
      @for (item of all() ?? []; track item) {
        <soft-ds-card
          density="compact"
          accent="primary"
          class="cursor-pointer"
          (click)="selectedChange.emit(item)"
          chevron
        >
          <soft-dynamic-object [value]="item" [definition]="$any(definition())" />
        </soft-ds-card>
      }
    </div>
  }
</div>
